<template>
  <div id="nav-side">
    <el-menu default-active="1" class="el-menu-vertical-demo nav-menu" theme="dark" style="z-iv-colndex: 3; width:100%;" :collapse="isCollapse" router>
      <el-submenu index="15" class="nav-side" id="dashboard">
        <template slot="title">
          <a href="/home" onclick="javascript:return false;">
            <router-link :to="{ name: 'Home' }">
              Home
            </router-link>
          </a>
        </template>
      </el-submenu>
      <!-- QUICK ADD -->
      <!--Payroll-->
      <el-submenu index="0" class="nav-side" id="payrollmenu" v-if="payrollEnabled">
        <template slot="title">
          <a href="/payroll/reports" onclick="javascript:return false;">
            <router-link :to="{ name: 'PrReport' }">
              ProPay
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Please select a function ...</span>
          <el-menu-item index="/payroll/reports">
            Payroll Reporting
          </el-menu-item>
          <el-menu-item index="/payroll/clientexport">
            Payroll Client Export
          </el-menu-item>
          <el-menu-item index="/payroll/prcheckregister">
            Payroll Check Register
          </el-menu-item>
          <el-menu-item index="/payroll/status">
            Payroll Status
          </el-menu-item>
          <el-menu-item index="/payroll/unionexport">
            Payroll Union Export
          </el-menu-item>
          <el-menu-item index="/payroll/ddexport">
            Payroll Direct Deposit Export
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="1" class="nav-side" id="quickadd">
        <template slot="title">Quick Add</template>
        <el-menu-item-group>
          <span slot="title">Create a New ...</span>
          <el-menu-item index="">
            <a href="/pos/new" target="_blank">
              <span>Purchase Order</span>
            </a>
          </el-menu-item>
          <el-menu-item index="">
            <a href="/aps/new" target="_blank">
              <span>A/P Invoice</span>
            </a>
          </el-menu-item>
          <el-menu-item index="">
            <a href="/pettycash/new" target="_blank">
              <span>Petty Cash Envelope</span>
            </a>
          </el-menu-item>
          <el-menu-item index="">
            <a href="/jes/new" target="_blank">
              <span>Journal Entry</span>
            </a>
          </el-menu-item>
          <el-menu-item index="" @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'vendor')">
            <span>Vendor</span>
          </el-menu-item>
          <el-menu-item index="">
            <a href="/programs/checks" target="_blank">
              Check Run
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- APs -->
      <el-submenu index="2" class="nav-side" id="accountspayable">
        <template slot="title">
          <a href="/aps" onclick="javascript:return false;">
            <router-link :to="{ name: 'APs' }">
              Accounts Payable
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Accounts Payable</span>
          <el-menu-item index="/aps">
            <a href="/aps" onclick="javascript:return false;">
              View All A/Ps
            </a>
          </el-menu-item>
          <el-menu-item index="/reports/apagingreport">
            <a href="/reports/apagingreport" onclick="javascript:return false;">
              Aging Report
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/posting?type=Aps">
            <a href="/programs/posting?type=Aps" onclick="javascript:return false;">
              Audit/Post
            </a>
          </el-menu-item>
          <el-menu-item index="/pos/new">
            <a href="/pos/new" onclick="javascript:return false;">
              <span>
                Add Purchase Order
              </span>
            </a>
          </el-menu-item>
          <el-menu-item index="/aps/new">
            <a href="/aps/new" onclick="javascript:return false;">
              <span>
                Add Invoice
              </span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/checks" v-if="checkIfUserHasRequiredPermissions(['entry.add_papercheck', 'entry.change_papercheck', 'entry.delete_papercheck'])">
            <a href="/programs/checks" onclick="javascript:return false;">
              Print Checks
            </a>
          </el-menu-item>
          <el-menu-item index="/checks">
            <a href="/checks" onclick="javascript:return false;">
              View All Checks
            </a>
          </el-menu-item>
          <el-menu-item index="/reports/checkregister">
            <a href="/reports/checkregister" onclick="javascript:return false;">
              Check Register
            </a>
          </el-menu-item>
          <el-submenu index="">
            <span slot="title">Vendors</span>
            <el-menu-item index="/vendors">
              <a href="/vendors" onclick="javascript:return false;">
                View all
              </a>
            </el-menu-item>
            <el-menu-item
              index=""
              v-if="checkIfUserHasRequiredPermissions(['system.add_vendor'])"
              @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'vendor')">
              <span>New Vendor</span>
            </el-menu-item>
          </el-submenu>
        </el-menu-item-group>
      </el-submenu>
      <!-- Payments -->
      <el-submenu index="14" class="nav-side" id="payments">
        <template slot="title">
          <a href="/payments" onclick="javascript:return false;">
            <router-link :to="{ name: 'Payments' }">
              Payments
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Payments</span>
          <el-menu-item index="/programs/payments">
            <a href="/programs/payments" onclick="javascript:return false;">
              Payment Processing
            </a>
          </el-menu-item>
          <el-menu-item index="/payments">
            <a href="/payments" onclick="javascript:return false;">
              View All Payments
            </a>
          </el-menu-item>
          <el-menu-item index="/reports/paymentregister">
            <a href="/reports/paymentregister" onclick="javascript:return false;">
              <span>
                Payment Register
              </span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/bankrecs">
            <a href="/programs/bankrecs" onclick="javascript:return false;">
              <span>
                Bank Reconciliation
              </span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/positivepay">
            <a href="/programs/positivepay" onclick="javascript:return false;">
              <span>
                Positive Pay
              </span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!--ARs-->
      <el-submenu index="3" class="nav-side" id="accountsreceivable" v-if="arEnabled">
        <template slot="title">
          <a href="/ars" onclick="javascript:return false;">
            <router-link :to="{ name: 'ARs' }">
              Accounts Receivable
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Accounts Receivable</span>
          <el-menu-item index="/ars">
            <a href="/ars" onclick="javascript:return false;">
              View All A/Rs
            </a>
          </el-menu-item>
          <el-menu-item index="/ars/new">
            <a href="/ars/new" onclick="javascript:return false;">
              <span>
                Add Bill
              </span>
            </a>
          </el-menu-item>
          <el-submenu index="3-1">
            <span slot="title">Bill Payments</span>
            <el-menu-item index="/bps">
              <a href="/bps" onclick="javascript:return false;">
                <router-link :to="{ name: 'BPs' }">
                  View All
                </router-link>
              </a>
            </el-menu-item>
            <el-menu-item index="/bps/new">
              <a href="/bps/new" onclick="javascript:return false;">
                <span>
                  Add Bill Payment
                </span>
              </a>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3-2">
            <span slot="title">Deposits</span>
            <el-menu-item index="/pps">
              <a href="/pps" onclick="javascript:return false;">
                <router-link :to="{ name: 'PPs' }">
                  View All
                </router-link>
              </a>
            </el-menu-item>
            <el-menu-item index="/pps/new">
              <a href="/pps/new" onclick="javascript:return false;">
                <span>
                  Add Deposit
                </span>
              </a>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3-3">
            <span slot="title">Customers</span>
            <el-menu-item index="/customers">
              <a href="/customers" onclick="javascript:return false;">
                View All
              </a>
            </el-menu-item>
            <el-menu-item index="" @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'customer')">
              <span>New Customer</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/salesreps">
            <a href="/salesreps" onclick="javascript:return false;">
              Sales Reps
            </a>
          </el-menu-item>
          <el-menu-item index="/billabletypes">
            <a href="/billabletypes" onclick="javascript:return false;">
              Billable Types
            </a>
          </el-menu-item>
          <el-menu-item index="/billableitems">
            <a href="/billableitems" onclick="javascript:return false;">
              Billable Items
            </a>
          </el-menu-item>
          <el-menu-item index="/markups">
            <a href="/markups" onclick="javascript:return false;">
              Markups
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="4" class="nav-side" id="pettycash">
        <template slot="title">
          <a href="/pcs" onclick="javascript:return false;">
            <router-link :to="{ name: 'PCs' }">
              Petty Cash
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Petty Cash</span>
          <el-menu-item index="/pettycash">
            <a href="/pettycash" onclick="javascript:return false;">
              View All P/Cs
            </a>
          </el-menu-item>
          <el-menu-item index="/pettycash/new">
            <a href="/pettycash/new" onclick="javascript:return false;">
              <span>Add PC Envelope</span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/posting?type=Pcs">
            <a href="/programs/posting?type=Pcs" onclick="javascript:return false;">
              <span>Audit/Post</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- JEs -->
      <el-submenu index="5" class="nav-side" id="journalentry" ref="je_submenu">
        <template slot="title">
          <a href="/jes" onclick="javascript:return false;">
            <router-link :to="{ name: 'JEs' }">
              Journal Entry
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Journal Entry</span>
          <el-menu-item index="/jes">
            <a href="/jes" onclick="javascript:return false;">
              View All J/Es
            </a>
          </el-menu-item>
          <el-menu-item index="/jes/new">
            <a href="/jes/new" onclick="javascript:return false;">
              <span>Add Journal Entry</span>
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/posting?type=Jes">
            <a href="/programs/posting?type=Jes" onclick="javascript:return false;">
              <span>Audit/Post</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!--PRs-->
      <el-submenu index="6" class="nav-side" id="payrollentry" ref="je_submenu">
        <template slot="title">
          <a href="/prs" onclick="javascript:return false;">
            <router-link :to="{ name: 'PRs' }">
              Payroll
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Payroll</span>
          <el-menu-item index="/prs">
            <a href="/prs" onclick="javascript:return false;">
              View All Payroll Entries
            </a>
          </el-menu-item>
          <el-menu-item index="/prs/new">
            <a href="/prs/new" onclick="javascript:return false;">
              <span>Add Payroll Entry</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- POs -->
      <el-submenu index="7" class="nav-side" id="purchaseorder">
        <template slot="title">
          <a href="/pos" onclick="javascript:return false;">
            <router-link :to="{ name: 'POs' }">
              Purchase Orders
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Purchase Orders</span>
          <el-menu-item index="/pos">
            <a href="/pos" onclick="javascript:return false;">
              View All P/Os
            </a>
          </el-menu-item>
          <el-menu-item index="/pos/new">
            <a href="/pos/new" onclick="javascript:return false;">
              <span>Add Purchase Order</span>
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- VENDORS -->
      <el-submenu index="8" class="nav-side" id="vendors">
        <template slot="title">
          <a href="/vendors" onclick="javascript:return false;">
            <router-link :to="{ name: 'Vendors' }">
              Vendors
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Vendors</span>
          <el-menu-item index="/vendors">
            <a href="/vendors" onclick="javascript:return false;">
              View All
            </a>
          </el-menu-item>
          <el-menu-item
            index=""
            v-if="checkIfUserHasRequiredPermissions(['system.add_vendor'])"
            @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'vendor')">
            <span>New Vendor</span>
          </el-menu-item>
          <el-menu-item index="/reports/vendorreport">
            Vendor History Report
          </el-menu-item>
          <el-menu-item index="/reports/vendorlist">
            Vendor List
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- CUSTOMERS -->
      <el-submenu index="9" class="nav-side" id="customers" v-if="arEnabled">
        <template slot="title">
          <a href="/customers" onclick="javascript:return false;">
            <router-link :to="{ name: 'Customers' }">
              Customers
            </router-link>
          </a>
        </template>
        <el-menu-item-group>
          <span slot="title">Customers</span>
          <el-menu-item index="/customers">
            <a href="/customers" onclick="javascript:return false;">
              View All
            </a>
          </el-menu-item>
          <el-menu-item index="" @click="openComponentCreateModal('changeModalVisibility', 'customerVendorForm', 'customer')">
            <span>New Customer</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- PROGRAMS -->
      <el-submenu index="10" class="nav-side" id="programs">
        <template slot="title">
          Programs
        </template>
        <el-menu-item-group>
          <span slot="title">Programs</span>
          <el-menu-item index="/programs/posting">
            <a href="/programs/posting" onclick="javascript:return false;">
              Transaction Posting
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/checks" v-if="checkIfUserHasRequiredPermissions(['entry.add_papercheck', 'entry.change_papercheck', 'entry.delete_papercheck'])">
            <a href="/programs/checks" onclick="javascript:return false;">
              Check Processing
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/payments" v-if="checkIfUserHasRequiredPermissions(['entry.add_papercheck', 'entry.change_papercheck', 'entry.delete_papercheck'])">
            <a href="/programs/payments" onclick="javascript:return false;">
              Payment Processing
            </a>
          </el-menu-item>
          <el-menu-item index="/programs/bankrecs" v-if="checkIfUserHasRequiredPermissions(['entry.add_papercheck', 'entry.change_papercheck', 'entry.delete_papercheck'])">
            <a href="/programs/bankrecs" onclick="javascript:return false;">
              <router-link :to="{ name: 'BankRecs' }">
                Bank Reconciliation
              </router-link>
            </a>
          </el-menu-item>
          <!-- <el-menu-item index="/programs/costreporter">
              <a href="/programs/costreporter" onclick="javascript:return false;">
                Cost Reporting
              </a>
            </el-menu-item> -->
          <el-submenu index="10-3">
            <span slot="title">
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                <span>Period Manager</span>
              </a>
            </span>
            <el-menu-item index="/programs/periodmanager">
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                View all periods
              </a>
            </el-menu-item>
            <el-menu-item index="/programs/periodmanager?closeCurrent=true">
              <i class="el-icon-circle-close"></i>
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                <span>Close Current Period</span>
              </a>
            </el-menu-item>
          </el-submenu>
        </el-menu-item-group>
      </el-submenu>
      <!-- REPORTS -->
      <el-submenu v-if="checkIfUserHasRequiredPermissions(['reports.view_reportrequest'])" index="11" class="nav-side" id="reports">
        <template slot="title">
          Reports
        </template>
        <el-menu-item-group>
          <template slot="title">
            Reports
          </template>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_cost_report'])" index="/programs/costreporter">
              <a href="/programs/costreporter" onclick="javascript:return false;">
              Cost Reporting
              </a>
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_trail_balance'])" index="/reports/trialbalance">
            Trial Balance
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_gl_bible_report'])" index="/reports/glreport">
            GL Bible Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_purchase_orders_report'])" index="/reports/poreport">
            Purchase Order Reports
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_ap_aging_report'])" index="/reports/apagingreport">
            AP Aging Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_check_register'])" index="/reports/checkregister">
            Check Register
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_history_report'])" index="/reports/vendorreport">
            Vendor History Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_vendor_list_report'])" index="/reports/vendorlist">
            Vendor List
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_chart_of_accounts_report'])" index="/reports/accountlist">
            Chart of Accounts List
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_asset_reporting_report'])" index="/reports/assetreport">
            Asset Report
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_1099_tax_reporting'])" index="/reports/taxreport2024">
            1099 Tax Reporting
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_audit_report_by_transaction'])" index="" @click="openComponentCreateModal('changeModalVisibility', 'audit/transaction')">
            Audit Report by Transaction
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_audit_report_by_account'])" index="" @click="openComponentCreateModal('changeModalVisibility', 'audit/account')">
            Audit Report by Account
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_posting_report_by_transaction'])" index="" @click="openComponentCreateModal('changeModalVisibility', 'posting/transaction')">
            Posting Report by Transaction
          </el-menu-item>
          <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_positing_report_by_account'])" index="" @click="openComponentCreateModal('changeModalVisibility', 'posting/account')">
            Posting Report by Account
          </el-menu-item>
          <!-- <el-menu-item v-if="checkIfUserHasRequiredPermissions(['auth.view_receivable_detail_report'])" index="" @click="openComponentCreateModal('changeModalVisibility', 'receivables/detail')">
            Receivable Detail Report
          </el-menu-item> -->
          <!--<el-menu-item index="" @click="openComponentCreateModal('changeModalVisibility', 'receivables/summary')">-->
            <!--Receivable Summary Report-->
          <!--</el-menu-item>-->
        </el-menu-item-group>
      </el-submenu>
      <!-- SETUP -->
      <el-submenu index="12" class="nav-side" id="setup">
        <template slot="title">
          Setup
        </template>
        <el-menu-item-group>
          <span slot="title">Setup</span>
          <el-menu-item index="/accounts">
            <a href="/accounts" onclick="javascript:return false;">
              Accounts (COA)
            </a>
          </el-menu-item>
          <el-menu-item index="/accountgroup">
            <a href="/accountgroup" onclick="javascript:return false;">
              Account Group
            </a>
          </el-menu-item>
          <el-menu-item index="/banks">
            <a href="/banks" onclick="javascript:return false;">
              Banks
            </a>
          </el-menu-item>
          <el-menu-item index="/companies">
            <a href="/companies" onclick="javascript:return false;">
              Companies
            </a>
          </el-menu-item>
          <el-menu-item index="/productions">
            <a href="/productions" onclick="javascript:return false;">
              Productions
            </a>
          </el-menu-item>
          <el-submenu index="12-1">
            <span slot="title">Codes</span>
            <el-menu-item index="/series">
              <a href="/series" onclick="javascript:return false;">
                Series
              </a>
            </el-menu-item>
            <el-menu-item index="/locations">
              <a href="/locations" onclick="javascript:return false;">
                Locations
              </a>
            </el-menu-item>
            <el-menu-item index="/sets">
              <a href="/sets" onclick="javascript:return false;">
                Sets
              </a>
            </el-menu-item>
            <el-menu-item index="/freefields">
              <a href="/freefields" onclick="javascript:return false;">
                Free Fields
              </a>
            </el-menu-item>
            <el-menu-item index="/taxcodes">
              <a href="/taxcodes" onclick="javascript:return false;">
                Tax Codes
              </a>
            </el-menu-item>
            <el-menu-item index="/insurancecodes">
              <a href="/insurances" onclick="javascript:return false;">
                Insurance Codes
              </a>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/currencies">
            <a href="/currencies" onclick="javascript:return false;">
              Currencies
            </a>
          </el-menu-item>
          <!-- <el-submenu index="12-2">
            <span slot="title">Periods</span>
            <el-menu-item index="/programs/periodmanager">
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                View all periods
              </a>
            </el-menu-item>
            <el-menu-item index="/programs/periodmanager?closeCurrent=true">
              <i class="el-icon-circle-close"></i>
              <a href="/programs/periodmanager?closeCurrent=true" onclick="javascript:return false;">
                <span>Close Current Period</span>
              </a>
            </el-menu-item>
          </el-submenu> -->
          <el-menu-item index="/programs/signaturecapture">
            <a href="/programs/signaturecapture" onclick="javascript:return false;">
              User Settings
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- SYSTEM -->
      <el-submenu index="13" class="nav-side" id="system">
        <template slot="title">
          System
        </template>
        <el-menu-item-group>
          <span slot="title">System</span>
          <el-menu-item index="/batches">
            <a href="/batches" onclick="javascript:return false;">
              Batches
            </a>
          </el-menu-item>
          <el-menu-item index="/budgets">
            <a href="/budgets" onclick="javascript:return false;">
              Budgets
            </a>
          </el-menu-item>
          <el-menu-item index="/budgetImport">
            <a href="/budgetImport" onclick="javascript:return false;">
              Budget Import
            </a>
          </el-menu-item>
          <!-- <el-submenu index="">
            <span slot="title">Periods</span>
            <el-menu-item index="/programs/periodmanager">
              <a href="/programs/periodmanager" onclick="javascript:return false;">
                View all periods
              </a>
            </el-menu-item>
            <el-menu-item index="/programs/periodmanager?closeCurrent=true">
              <i class="el-icon-circle-close"></i>
              <span>Close Current Period</span>
            </el-menu-item>
          </el-submenu> -->
          <el-menu-item index="/states">
            <a href="/states" onclick="javascript:return false;">
              States
            </a>
          </el-menu-item>
          <el-menu-item index="/countries">
            <a href="/countries" onclick="javascript:return false;">
              Countries
            </a>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        isCollapse: true
      }
    },
    methods: {
      /**
       * Handles opening an app-wide create modal, such as new customer, vendor or new account
       * @param modalOpenAction
       * @param entityType
       * @param type
       */
      openComponentCreateModal (modalOpenAction, entityType, type = null) {
        if (type) {
          this.$store.dispatch(modalOpenAction, { entityType, visible: true, type })
        } else {
          this.$store.dispatch(modalOpenAction, { entityType, visible: true })
        }
      }
    },
    computed: {
      ...mapGetters({
        instance: 'getActiveInstance',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions'
      }),
      /**
       * Checks the instance settings and determines whether AR module should be shown
       * @return {boolean}
       */
      arEnabled () {
        return !!this.$store.getters.getUiSettings['AR_ENABLED']
      },
      payrollEnabled () {
        return !!this.$store.getters.getUiSettings['PAYROLL_ENABLED']
      },
      /**
       * Checks the instance settings and determines whether beta Cost Reporter should be shown
       * @return {boolean}
       */
      costReporterBetaEnabled () {
        return !!this.$store.getters.getUiSettings['COST_REPORTER_BETA_ENABLED']
      },
      achEnabled () {
        return !!this.$store.getters.getUiSettings['ACH_ENABLED']
      }
    }
  }
</script>

<style scoped>
  .el-menu-item.is-active, .el-menu a:visited, span a:visited {
    text-decoration: none !important;
    color: #bfcbd9 !important;
  }
  .menuItem {
    padding: 0;
  }
  .menuItemRouterLink {
    padding-left: 10px;
    display: block;
  }
</style>

<style>
  #nav-col {
    width: 165px;
  }
  .nav-side {
    text-align: left;
  }
  .nav-side .el-menu-item-group__title {
    padding: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    background: transparent;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-submenu__title * {
    vertical-align: middle;
    color: #ccc !important;
}
  ul.el-menu {
    background: transparent;
  }
  .el-submenu__title {
      height: 35px !important;
      line-height: 35px !important;
  }
  .el-submenu__title:hover {
    background: #ccc;
  }
  .el-submenu .el-menu-item{
      height: 35px !important;
      line-height: 35px !important;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/NavSide.vue